module.exports = __webpack_public_path__ + "static/media/woocommerce-logo.c418d2a9.png";